import produce from "immer"
import { ASC } from "const"
import { MarkovVariable } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovVariable: MarkovVariable = {
    id: null,
    modelId: null,
    name: "",
    expression: "",
    order: null,
}

const initMarkovVariableState: types.MarkovVariableState = {
    variableList: {},
    variableListByName: {},
    variableIds: [],
    variableEdit: initMarkovVariable,

    variableDelete: null,

    sortColumn: "order",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const markovVariableReducer = produce((
    draft: types.MarkovVariableState = initMarkovVariableState,
    action: ActionTypes = null,
): types.MarkovVariableState => {
    switch (action.type) {
        case types.MARKOV_VARIABLE_LIST:
            draft.variableList = action.variableList
            draft.variableListByName = action.variableListByName
            return draft

        case types.MARKOV_VARIABLE_IDS:
            draft.variableIds = action.variableIds
            return draft

        case types.MARKOV_VARIABLE_EDIT:
            draft.variableEdit = action.variable
            return draft

        case types.MARKOV_VARIABLE_DELETE:
            draft.variableDelete = action.variable
            return draft

        case types.MARKOV_VARIABLE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_VARIABLE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MARKOV_VARIABLE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_VARIABLE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovVariableReducer
